const alias = 'BRANCHES_BY_INSTITUTION';

export const GET_BRANCHES_BY_INSTITUTION_REQUEST = `GET_${alias}_REQUEST`;
export const GET_BRANCHES_BY_INSTITUTION_SUCCESS = `GET_${alias}_SUCCESS`;
export const GET_BRANCHES_BY_INSTITUTION_FAILURE = `GET_${alias}_FAILURE`;

export const CLEAR_BRANCH_FETCH = `CLEAR_BRANCH_FETCH`;
